module.exports = __webpack_public_path__ + "static/media/courses.f27df378.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainmenus/courses.png
// module id = 2934
// module chunks = 0